import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { ActionStatus, ActionType } from "../../data/crmGeneralData";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
import { useAddAction, useGetCustomer } from "../../hooks/useCrm";
import { DataPicker } from "../DataPicker/DataPicker";
const initvalue = {
  IdS0alesOpportunities: null,
  SubjectActivityCrm: "",
  DescriptionActivityCrm: "",
  StatusActivityCrm: "",
  DateReferenceActivityCrm: "",
  meIdUserSabtActivityCrm: "خودم",
};

export const AddActionModal = ({ show, handleClose, userdata }) => {
  const [form, setForm] = useState(initvalue);
  const [button] = useState(false);
  const { mutateAsync: AddAction, isLoading: NewActionLoading } =
    useAddAction();
  const handleAddAction = async (action) => {
    await AddAction(action).then(() => setForm(initvalue));
  };
  useEffect(() => {
    setForm({
      ...form,
      IdS0alesOpportunities:
        userdata?.sales_opportunities[0].IdS0alesOpportunities,
    });
  }, [userdata]);
  const setDateFunction = (date) => {
    const finalDate = date?.year + "-" + date?.month + "-" + date?.day;
    setForm({ ...form, DateReferenceActivityCrm: finalDate });
  };
  const actionType = ActionType.map((action) => {
    return {
      value: action.value,
      label: action.label,
    };
  });
  const actionStatus = ActionStatus.map((action) => {
    return {
      value: action.value,
      label: action.label,
    };
  });
  const { data: customerresponsible } = useGetCustomer();
  const customerResponsible = customerresponsible?.data?.Colleague;
  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });

  return (
    <BootstrapModal
      modaltitle="افزودن فعالیت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="lg"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <SimpleSelect1
            label={"عنوان فعالیت"}
            res={actionType}
            onChange={(e) =>
              setForm({
                ...form,
                SubjectActivityCrm: e.value,
              })
            }
            placeholder="هیچکدام"
          />
          <SimpleTextArea
            label="توضیح فعالیت"
            cols="10"
            rows="3"
            placeholder="توضیح فعالیت را بنویسید..."
            onChange={(e) =>
              setForm({ ...form, DescriptionActivityCrm: e.target.value })
            }
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12">
          <SimpleSelect1
            label={"وضعیت"}
            res={actionStatus}
            onChange={(e) =>
              setForm({
                ...form,
                StatusActivityCrm: e.value,
              })
            }
            placeholder="هیچکدام"
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12">
          <SimpleSelect1
            label={"تغییر مسئول"}
            res={customerResponsibleOptions}
            onChange={(e) =>
              setForm({
                ...form,
                meIdUserSabtActivityCrm: e.value,
              })
            }
            placeholder="خودم"
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12">
          <DataPicker
            label="تاریخ فعالیت"
            onChange={(event) => setDateFunction(event)}
          />
        </div>
        <div className="col-12">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleAddAction(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
      </div>
      {/* <InputField1
        onChange={handleChange}
        name={"RecipientName"}
        label={"نام و نام خانوادگی تحویل گیرنده"}
        type={"text"}
        placeholder={"نام و نام خانوادگی تحویل گیرنده"}
        id={"NameAndFamily"}
        className={"form-control"}
      ></InputField1> */}
    </BootstrapModal>
  );
};
